/* Navigation list styles with improved accessibility */
.navList {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}

.navListItem {
  margin: 2px 0;
  padding: 0;
  list-style-type: none;
  display: block;
}

.navListItem a {
  display: block;
  border-radius: 3px;
  color: light-dark(white, var(--brand-grey-200));
  padding: 4px 15px;
  font-weight: 400;

  cursor: pointer;
  transition: color 0.15s linear;

  &[aria-current] {
    background-color: var(--brand-blue-500);
  }

  & span {
    border-bottom: 1px solid transparent;
  }
}

.navListItem a:is(:hover, :active, :focus-visible) {
  color: light-dark(white, var(--brand-blue-50));
  background-color: light-dark(var(--brand-blue-500), var(--brand-grey-600));

  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  & span {
    color: var(--brand-blue-100);
  }
}

/* Focus styles for keyboard navigation */
.navListItem a:focus-visible {
  outline: 2px solid var(--brand-blue-200);
  outline-offset: -2px;
}
